import './Pagination.scss';
import classnames from 'classnames';
import { FC, ReactNode } from 'react';

export type PaginationLayoutProps = {
  children: ReactNode;
  className?: string;
  isSmall?: boolean;
};

export const PaginationLayout: FC<PaginationLayoutProps> = ({ className, isSmall, children }) => {
  return (
    <div
      className={classnames(
        'blotter-pagination-component d-flex container-fluid pagination-summary p-1 py-2 gap-4',
        className,
        {
          'pagination-sm': isSmall,
        },
      )}
      data-e2e="blotter-pagination"
    >
      {children}
    </div>
  );
};

PaginationLayout.displayName = 'PaginationLayout';
